// ThemeToggleButton.js
import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PaletteIcon from "@mui/icons-material/Palette";
import { useTheme } from "@mui/material/styles";
import { useThemeContext } from "../styles/ThemeContext";

const themes = ["goat", "stylisher", "dark", "light"];

const ThemeToggleButton = () => {
  const { themeName, setTheme } = useThemeContext();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (selectedTheme) => {
    setTheme(selectedTheme);
    handleClose();
  };

  return (
    <>
      <Tooltip title={`Switch Theme (current: ${themeName})`}>
        <IconButton onClick={handleOpen}>
          <PaletteIcon sx={{ color: theme.palette.accent.main }} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
      >
        {themes.map((t) => (
          <MenuItem
            key={t}
            selected={t === themeName}
            onClick={() => handleSelect(t)}
          >
            {t.charAt(0).toUpperCase() + t.slice(1)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ThemeToggleButton;